import { emit, on } from '@/events/eventBus'

export const DOCUMENT_PREVIEW_EVENTS = {
  OPEN_REQUESTED: 'document_preview:open_requested',
}

/**
 * @param {import('./documentPreviewTypes.js').DocumentPreviewSelection} selection
 */
export function emitDocumentPreviewOpenRequested(selection) {
  emit(DOCUMENT_PREVIEW_EVENTS.OPEN_REQUESTED, selection)
}

/**
 * @param {(selection: import('./documentPreviewTypes.js').DocumentPreviewSelection) => void} handler
 * @returns {() => void}
 */
export function onDocumentPreviewOpenRequested(handler) {
  return on(DOCUMENT_PREVIEW_EVENTS.OPEN_REQUESTED, (payload) => {
    if (payload && typeof payload === 'object' && 'artifactId' in payload) {
      handler(/** @type {import('./documentPreviewTypes.js').DocumentPreviewSelection} */ (payload))
    }
  })
}
